#import "./srcset.graphql"

fragment DefaultImageAsset on AssetInterface {
    id
    width
    height
    focalPoint
    hasFocalPoint
    url
    webp: url @transform(immediately: true, format: "webp", quality: 84)
#    avif: url @transform(immediately: true, format: "avif")
    ... srcset
}
